import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  Input,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { iconClose2, iconExtremelyDelayed, iconOnTime } from '../../svg-icons';
import { IconManager } from '../../services/icon-manager.service';
import { SnackbarService } from './snackbar.service';

@Component({
  selector: 'twc-snackbar',
  imports: [CommonModule, MatIconModule],
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SnackbarComponent {
  private _iconManager = inject(IconManager);
  private _snackbarService = inject(SnackbarService);

  @ViewChild('snackbar', { static: true }) snackbarElementRef!: ElementRef;

  @Input() snackbarData: any;
  constructor() {
    this._iconManager.addIcons([
      {
        name: 'close-2',
        icon: iconClose2,
      },
      {
        name: 'on-time',
        icon: iconOnTime,
      },
      {
        name: 'info',
        icon: iconExtremelyDelayed,
      },
    ]);
  }

  removeSnackbar(id: number) {
    this._snackbarService.removeNotification(id);
  }

  onActionClick() {
    this.removeSnackbar(this.snackbarData.id);
    this.snackbarData?.action.actionCallback();
  }
}
